import React from 'react';
import { compose } from 'recompose';
import Layout from '../utils/layout';
import GameBuilder from '../components/scenes/GameBuilder/GameBuilder';

import {
  withAuthorization,
  withEmailVerification,
} from '../utils/Session';

const condition = (authUser) => !!authUser;
const GameBuilderPage = compose(
  withEmailVerification,
  withAuthorization(condition),
)(GameBuilder);

export default () => (
  <Layout>
    <GameBuilderPage />
  </Layout>
);
